import {
    action,
    computed, makeAutoObservable, observable
} from 'mobx';
// import config from '../configs_/config.js';
import { formatCurrency } from '../utils/Currency.js';
// import ArManagerClass from '../utils/AR';
import { sanitizeColor } from '../utils/Colors.js';
import { isIOS, isMobileDevice } from '../utils/Device';
import { delay, throttle } from '../utils/Events';
import { deepCopy } from '../utils/Object.js';
import SketchfabControllerClass from '../utils/SketchfabController';
import { getCategoriesTree, saveScreenshoot } from '../utils/api.js';
import { publicUrl } from '../utils/url.js';
import { CartClass, post } from './Cart.js';
import { Product } from './Product.js';
import { SelectedMaterial } from './SelectedMaterial';
import ArManagerClass from './AR.js';
// import { swalAlert } from '../utils/Swal.js';

const QRCode = require('qrcode')
const BREAKPOINT_XL = 1200;
const PUBLIC_URL = process.env.PUBLIC_URL || '/';

class StoreClass {
    // config = config1
    sf: SketchfabControllerClass;
    cart:CartClass
    ar: ArManagerClass

    langCode = String(document.documentElement.lang).replace(/-.+$/,'').toLowerCase() || 'en';
    
    isAccordionOpenByDefault = window.innerWidth > BREAKPOINT_XL;
    isAccordionInteractive = window.innerWidth < BREAKPOINT_XL;

    @observable config;
    @observable preloading = true
    @observable pendingRequest = true
    @observable currentOpenAccordion = 1
    @action openAccordion(id) {
        this.currentOpenAccordion = id;
    }
    @action updateCurrentOpen(id){
        if(this.currentOpenAccordion === id){
            this.currentOpenAccordion = null;
        }else{
            this.currentOpenAccordion = id;
        }
    }
    @observable isOpen = false
    @action hideLoader(){
        this.pendingRequest = false;
    }
    @action showLoader(){
        this.pendingRequest = true;
    }
    @observable isMobileDevice = isMobileDevice();




    @observable selectedCategoryId;
    @observable selectedSubategoryId;
    @computed get categories(){
        return this.config?.categories || [];
    }
    @computed get subcategories(){
        if(this.currentCategory?.children?.length){
            const defaultId = this.config?.defaultConfiguration.find(d => this.__matches({ category_id: d.category_id, subcategory_id: null }));
            const subCategoryId = defaultId && this.materials.find(p=>p.id === defaultId.id)?.subcategory_id;

            // return this.currentCategory.children;
            return this.currentCategory.children.slice().sort((a, b) => {
                if (a.id != subCategoryId) {
                    // return 0;
                    return parseInt(a['position']) - parseInt(b['position']);
                }
                return -1;
            });
            
        }
        return [];
    }
    @action async selectCategory(id){
        this.selectedCategoryId = id;
        const subcategory_id = this.selectedMaterials.find(m => m.category_id === id)?.subcategory_id;
        if(subcategory_id) {
            this.selectedSubategoryId = subcategory_id;
        }else{
            this.selectedSubategoryId = this.currentCategory?.children[0]?.id;
        }

        // this.openAccordion(store.currentMaterials[0]?.id);
        if(this.config.multiCamera) {
            if(this.currentCategory?.cameraConstraints){
                const {target, position} =  this.currentCategory?.cameraConstraints
                await this.sf.setCameraLookAt(position, target, 0.8);
                // await this.sf.setEnableCameraConstraints(true, this.currentCategory.cameraConstraints);
                await this.sf.setCameraConstraints(this.currentCategory.cameraConstraints);
            } else if(this.config?.cameraConstraints){
                const {target, position} = this.config.cameraConstraints;
                await this.sf.setCameraLookAt(position, target, 0.8);
                // await this.sf.setEnableCameraConstraints(true, this.config.cameraConstraints);
                await this.sf.setCameraConstraints(this.config.cameraConstraints);
            }
        }
        this.render(['category']);
       
    }
    @action async selectSubcategory(id){
        this.selectedSubategoryId = id;
        // this.openAccordion(store.currentMaterials[0]?.id);
        if(this.config.multiCamera) {
            if(this.currentSubcategory?.cameraConstraints){
                const {target, position} =  this.currentSubcategory?.cameraConstraints
                await this.sf.setCameraLookAt(position, target, 0.8);
                // await this.sf.setEnableCameraConstraints(true, this.currentCategory.cameraConstraints);
                await this.sf.setCameraConstraints(this.currentSubcategory.cameraConstraints);
            } else if(this.config?.cameraConstraints){
                const {target, position} = this.config.cameraConstraints;
                await this.sf.setCameraLookAt(position, target, 0.8);
                // await this.sf.setEnableCameraConstraints(true, this.config.cameraConstraints);
                await this.sf.setCameraConstraints(this.config.cameraConstraints);
            }
        }
       
    }
    
    @computed get currentCategory(){
        return this.categories.find(c => c.id === this.selectedCategoryId)
    };
    @computed get currentSubcategory(){
        return (this.currentCategory?.children||[]).find(c => c.id === this.selectedSubategoryId)
    };

    __matches = ({category_id, subcategory_id}) => {
        if (this.selectedSubategoryId && subcategory_id) {
            return subcategory_id === this.selectedSubategoryId;
        }
        return category_id === this.selectedCategoryId;
    };
    @computed get currentMaterials(){
        var items = [];
        if(this.currentCategory?.remove){
            const{label, size} = this.currentCategory.remove;
            items.push({
                name: label,
                battery_icon_text: label,
                className: size,
                price: 0
            });
        }
        

        var materials = this.materials.filter(m => {
            // if(this.selectedSubategoryId){
            //     return m.subcategory_id === this.selectedSubategoryId;
            // }
            return this.__matches({ category_id: m.category_id, subcategory_id: m.subcategory_id });
        });

        items = items.concat(materials);
        const defaultId = this.config?.defaultConfiguration.find(d => this.__matches({ category_id: d.category_id, subcategory_id: null }));
        if (defaultId) {
            items = items.sort((a, b) => {
                if (a.id != defaultId.id) {
                    return 0;
                }
                return -1;
            })
        }
        return items;

        // if(!this.currentCategory?.children || this.currentCategory?.children.length === 0){
        //     return this.currentCategory?.products || [];
        // }
        // return this.currentSubcategory?.products || []
    };


    @observable selectedMaterials:SelectedMaterial[] = []
    @computed get hash(){
        return this.selectedMaterials.map(s=> `C${s.id}ID${s.category_id}`).join('_');
    }

   
    
    /**
     */
    @computed get materials():Product[]{

        function applyColor(...colors){
            for (let index = 0; index < colors.length; index++) {
                const c = colors[index];
                if(c){
                    return sanitizeColor(c)
                }
                
            }
        }
        const materials = [];
        this.categories.forEach(c => {
            const channels = c['channels'] || [];
            c.children.forEach(m => {
                (m.products || []).forEach(product => {
                    const channels = product['channels'] || m['channels'] || c['channels'];
                    const catChannels = m['channels'] || c['channels'];
                    materials.push(new Product({
                        ...product,
                        store: this,
                        subcategory: m,
                        category: c,
                        thumbnail: product['thumbnail'] || m['thumbnail'],
                        color: sanitizeColor(product['color']),
                        color2: sanitizeColor(product['color2']),
                        category_id: c.id,
                        subcategory_id: m.id,
                        // description: m?.description,
                        showNodes: m?.showNodes,
                        hideNodes: m?.hideNodes,
                        channels: channels.map(({ material_name, colorFieldName, channels, thumbnail }) => {
                            const channelsCopy = {...deepCopy(catChannels?.find(c => c.material_name === material_name)?.channels), ...deepCopy(channels)};
                            if(channelsCopy?.AlbedoPBR){
                                channelsCopy.AlbedoPBR.color = applyColor(channelsCopy?.AlbedoPBR?.color, product[colorFieldName])
                            }
                            return {
                                material_name,
                                colorFieldName,
                                thumbnail,
                                channels: channelsCopy
                            }
                        })
                    }));
                });
            });
            (c.products||[]).forEach(product => {
                
                materials.push(new Product({
                    ...product,
                    store:this,
                    subcategory: null,
                    category: c,
                    thumbnail: product['thumbnail'],
                    color: sanitizeColor(product['color']),
                    color2: sanitizeColor(product['color2']),
                    category_id: c.id,
                    subcategory_id: null,
                    showNodes: c?.showNodes,
                    hideNodes: c?.hideNodes,
                    channels: channels.map(({ material_name, colorFieldName, channels, thumbnail }) => {
                        const channelsCopy = deepCopy(channels);
                        if(channelsCopy?.AlbedoPBR){
                            channelsCopy.AlbedoPBR.color = applyColor(channelsCopy?.AlbedoPBR?.color, product[colorFieldName])
                        }
                        return {
                            material_name,
                            colorFieldName,
                            thumbnail,
                            channels: channelsCopy
                        }
                    })
                }));
            });
        })
        return materials;
    }

    isSelected(category_id, material_id){
        const found = this.selectedMaterials.find(m => m.id === material_id && m.category_id === category_id);
        const hasSome = this.selectedMaterials.some(s=>s.category_id === category_id);
        return Boolean(found) || (material_id === undefined && !hasSome);
    }

    @action async selectMaterial(category_id, material_id){
        const mat = this.materials.find(m => m.category_id === category_id && m.id === material_id);
        const currentMaterial = this.selectedMaterials.find(m => m.category_id == category_id);
        const selectedMaterials = this.selectedMaterials.filter(m => m.category_id !== category_id);
        // console.log('selectedProduct',{
        //     category_id,
        //     product_id: material_id,
        //     product: mat,
        //     channels: mat?.channels
        // });

        if (!mat && currentMaterial) {
            // console.log("no material", { currentMaterial });
            if(currentMaterial.material){
                await this.sf.hideNodes(currentMaterial.material.hideNodes);
                await this.sf.hideNodes(currentMaterial.material.showNodes);
            }
            this.selectedMaterials = selectedMaterials;
        }else if(mat){
            const s = new SelectedMaterial({ 
                store: this,
                id: mat.id, 
                category_id: category_id
            });
            if(mat.hideNodes) {
                // let hideNodes = []
                // for (let hideNode of mat.hideNodes) {
                //     hideNodes.push(hideNode.);
                // }
                await this.sf.hideNodes(mat.hideNodes);
                // console.log("hide", mat.hideNodes);
            }
            if(mat.showNodes) {
                // let showNodes = []
                // for (let showNode of mat.showNodes) {
                //     showNodes.push(showNode.)
                // }
                await this.sf.showNodes(mat.showNodes);
                // console.log("show", mat.showNodes);
            }
            // console.log({mat});
            selectedMaterials.push(s);
            this.selectedMaterials = selectedMaterials;
            await s.preloadTextures();
            // this.sf.loadTextures(s.texturesUrls);

        }


        this.render(['material']);

    }

    @action render(changed = []){

        // sizes
        // this.sf.hideNodes(this.sizes.map(n=>n.node));
        // if(this.selectedSize){
        //     this.sf.showNode(this.selectedSize.node);
        // }

        // this.categories.forEach(c => {
        //     const product = this.selectedMaterials.find(s => s.category_id === c.id);
        //     if(!product){
        //         // if(c.products?.length > 0){
        //             console.log('hide', ...c.showNodes);
        //             this.sf.hideNodes(c.showNodes);
        //         // }
        //     }
        // });
        // if(changed.includes('category')){
        //     const ld = this.categories.find(c => c.id === 50);
        //     const sd = this.categories.find(c => c.id === 38);
        //     switch (this.selectedCategoryId) {
        //         case 50:
        //             this.sf.
        //             break;
            
        //         default:
        //             break;
        //     }
        // }

        if(this.materials.length > 0){
       
            this.selectedMaterials.forEach((s) => {
                // const material_names = s.material.material_name;
                const category_id = s.category_id;
                const selectedMaterial = this.selectedMaterials.find(m => m.category_id === category_id);
                let UVmap;
                
                s.channels.map(({ material_name, channels }) => { 
                    
                    const mat = this.sf.findMaterialByName(material_name);
                    if(mat && selectedMaterial){
                        const channelsCopy = deepCopy(channels);
                        for (const channelName in channelsCopy) {
                            if (Object.hasOwnProperty.call(channelsCopy, channelName)) {
                                const channel = channelsCopy[channelName];
                                const UVmapM = channelsCopy[channelName]?.UVmap || {};
                                const UVmapInheritedFromAccordion = mat[channelName]?.UVmap || {};
                                const newChannelValue = {...mat[channelName], ...channel};
                                mat.channels[channelName] = newChannelValue;
    
                                // apply UVmap
                                const UVmap = {...UVmapInheritedFromAccordion, ...UVmapM};
                                
                                if(UVmap['rotation'] !== undefined){
                                    this.sf.setUVRotation(mat, channelName, UVmap['rotation']);
                                }else{
                                    this.sf.setUVRotation(mat, channelName, 0);
                                }
                                if(UVmap['scaleX'] !== undefined && UVmap['scaleY'] !== undefined){
                                    this.sf.setUVScale(mat, channelName, UVmap['scaleX'], UVmap['scaleY']);
                                }else{
                                    this.sf.setUVScale(mat, channelName, 1, 1);
                                }
                                if(UVmap['offsetX'] !== undefined && UVmap['offsetY'] !== undefined){
                                    this.sf.setUVRotation(mat, channelName,  UVmap['offsetX'], UVmap['offsetY']);
                                }else{
                                    this.sf.setUVRotation(mat, channelName, 0, 0);
                                }
                            
                                
                            }
                        }
                        // console.log(`Updating material ${material_name}`, {
                        //     mat, 
                        //     material: selectedMaterial.material, 
                        //     channelsCopy,
                        //     UVmap
                        // });
                        this.sf.setMaterial(mat);
                        
                    }
                        
                    
                })
                
                s.render();
            });
        }

    }

    

   

    constructor() {
        makeAutoObservable(this)

        this.cart = new CartClass({
            store:this
        });

        this.ar = new ArManagerClass({
            store: this,
        });


        
        
        window.addEventListener('resize', this.onResize, { passive: true });
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onResize();

        // document.addEventListener('click', e=>{
        //     console.log({
        //         target: e.target,
        //         currentTarget: e.currentTarget
        //     });
        //     // if(e.target && e.target.dataset.confId){
        //         // }
        // });
        
        
        setTimeout(()=>{
            // this.loadConfiguration();
            this.onResize();
        },200);
    }

 
    
    @action showError(err){
        this.error = err;
        throw new Error(err);
    }

    showModal(){
        this.isOpen = true;
    }
    hideModal(){
        this.isOpen = false;
    }
    
    @action async selectDefaultMaterials(){
        var promises = [];
        this.selectedCategoryId = this.categories[0].id;
        // this.categories.forEach(c => {
        //     // if(c.materials.length > 0){
        //     //     const promise = this.selectMaterial(c.id, c.materials[0].colors[0].id);
        //     //     promises.push(promise);
        //     // }
        // });
        // this.updateCurrentOpen(this.currentMaterials[0].id);
        this.config.defaultConfiguration.forEach(({category_id, id}) => {
            var p = this.selectMaterial(category_id, id);
            promises.push(p);
        });

        return Promise.all(promises);
    }

    async fetchJSON(name){
        var pubUrl = publicUrl(`/configs/${name}`);
        return fetch(pubUrl).then(r => r.json()).then(json => {
            return json;
        });
    }

    @action async preloadConfiguration(filename){
        var materialsSets = {};

        const root = await getCategoriesTree();
        
        // materialsSets['woodMaterials.json'] = await this.fetchJSON('woodMaterials.json');
        // materialsSets['rattanMaterials.json'] = await this.fetchJSON('rattanMaterials.json');
        // materialsSets['metalMaterials.json'] = await this.fetchJSON('metalMaterials.json');
        // materialsSets['fabricMaterials.json'] = await this.fetchJSON('fabricMaterials.json');
        // materialsSets['footrestMaterials.json'] = await this.fetchJSON('footrestMaterials.json');
        // materialsSets['woodAndMetalMaterials.json'] = await this.fetchJSON('woodAndMetalMaterials.json'); 
        // materialsSets['metalAssegaiMaterials.json'] = await this.fetchJSON('metalAssegaiMaterials.json');

        // const prepareIcon = name => {
        //     switch (name) {
        //         case 'battery':
        //             return 'battery.svg';
        //             break;
        //         case 'frame':
        //             return 'spray.svg';
        //             break;
        //         case 'side-panel':
        //             return 'panels.svg';
        //             break;
        //         case 'desk':
        //             return 'tabledesign.svg';
        //             break;
            
        //         default:
        //             return `${name}.svg`;
        //             break;
        //     }
        // }

        // root.data.children = root.data.children.map(c => {
        //     c.icon = prepareIcon(c.link_rewrite.en);
        //     return c;
        // });
       

        return fetch(publicUrl(`configs/${filename}`)).then(r => r.json()).then(json => {
            // json.categories.forEach((m,i)=>{
            //     json.categories[i].materials = materialsSets[m.material_set_name];
            // });

            const joinProducts = (p1l, p2l, reverse = false) => {
                var products = (p1l||[]).map(p1 => {
                    var p2 = (p2l||[]).find(_p => _p.id === p1.id);
                    if(reverse){
                        if(!p2){
                            return null;
                        }
                        return {...p2, ...p1}
                    }
                    if(!p1){
                        return null;
                    }
                    return {...p1, ...p2}
                }).filter(p=>!!p);
                return products;
            }

            json.categories = json.categories.map(c => {
                const store_category = root.data.children.find(_c => _c.id === c.id);
                // subcategories
                c.children = (c.children||[]).map(s => {
                    const store_subcategory = (store_category.children||[]).find(_s => _s.id === s.id)
                    // products
                    if(store_subcategory){
                        s.products = joinProducts(store_subcategory.products, s.products);
                        delete store_subcategory['children'];
                        delete store_subcategory['products'];
                    }else{
                        return null;
                    }


                    return {...s, ...store_subcategory}
                }).filter(c => !!c);
                if(store_category){
                    delete store_category.children;
                }
                var products = joinProducts(c.products, store_category.products, true);

                return {...c, ...store_category, products };
            });
            this.config =  json;
        });
    }

    @action async loadConfiguration(){
        console.log('loadConfiguration');
        this.pendingRequest = true;
        this.selectedMaterials = [];
        this.selectedCategoryId = null;
        this.selectedSizeId = null;
        this.currentOpenAccordion = null;
        this.config = null;

        try {
            await this.preloadConfiguration(`config.json`)
            .catch(e =>{
                // console.error(e);
                console.error(`Error while loading configuration`, {e});
                // swalAlert({
                //     text: 'something went wrong'
                // });
                throw e;
            });
            this.sf = new SketchfabControllerClass({
                uid: this.config.sketchfabId
            });
            this.showModal();
            await this.sf.init();

            this.sf.hideNodes(["O_desk1", "O_desk2", "O_desk3", "O_desk4"]);
            
            // await this.sf.setEnableCameraConstraints(false);
            await this.sf.setCameraLookAt([
                6.640461278207966,
                9.524245134156304,
                4.005216269910056
              ],
               [
                0.0033666106203402344,
                0.005670249462127706,
                0.3828945795318208
              ]);
            

            // if(!this.selectedSize && this.sizes.length > 0){
            //     this.updateSize(this.sizes[0].id)
            // }
            await this.selectDefaultMaterials();
            this.render();

            await delay(700);

            
            if(this.config?.cameraConstraints){
                const {target, position} = this.config.cameraConstraints;
                // await this.sf.setCameraLookAt(position, target);
                // await this.sf.setCameraConstraints(this.config.cameraConstraints);
            }else{
                // store.sf.zoom(1.1);
            }
            // await this.sf.setCameraLookAt([-2,-2,2], [0, 0, 0.3]);
            // await this.sf.setCameraConstraints({
            //     "position": [
            //         -2,
            //         -2,
            //         2
            //     ],
            //     "target": [
            //         0,
            //         0,
            //         0.3
            //     ],
            //     // "fov": 15,
            //     // "nearFarRatio": 0.005,
            //     // "useCameraConstraints": true,
            //     // "usePanConstraints": true,
            //     "useZoomConstraints": true,
            //     // "usePitchConstraints": true,
            //     // "useYawConstraints": true,
            //     "zoomIn": 1.5,
            //     "zoomOut": 4,
            //     "left": 1.6644929497966974,
            //     "right": -1.6644929497966974,
            //     "up": 1.555089,
            //     "down": -0.14551434605270586
            // });
          
        } catch (err) {
            console.error(err);
        } finally{
            this.preloading = false;
            this.pendingRequest = false;
            this.sf.setCameraLookAt([
                -1.932235754159364,
                3.721627153377979,
                2.2664729551177927
                ],
                [
                    0.0033666106203402344,
                    0.005670249462127706,
                    0.3828945795318208
                ], 5);
            // await delay(1100);
            // this.sf.gotoAnnotation('2', true);
        }
        
    }

    @observable locked = false;
    /**
     * Lock orientation for mobile devices:  
     * https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation/lock
     */
    @action async lockOrientation() {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        if (vw > vh && vw < 1000) {
            this.locked = true;
        } else {
            this.locked = false;
        }
        if (Math.max(vw, vh) < 1000) {
            try {
                // lock orientaion for screens smaller than 1000px
                await window.screen.orientation.lock('portrait');
            } catch (error) {
                console.error(error);
            }
        }
    }


    @action onResize = throttle((e) => {
        const renderTopOffset = document.querySelector('.SketchfabRender')?.getBoundingClientRect()?.top || 0;
        window.document.documentElement.style = `--scroll-y: ${window.scrollY}px; --height-y: ${window.innerHeight}px; --render-top-offset: ${renderTopOffset}px;`;
    
        
        this.isAccordionOpenByDefault = window.innerWidth > BREAKPOINT_XL;
        this.isAccordionInteractive = window.innerWidth < BREAKPOINT_XL;
        this.isMobileDevice = isMobileDevice();
        this.lockOrientation();
    }, 20)
    @action onScroll = throttle((e) => {
        const renderTopOffset = document.querySelector('.SketchfabRender')?.getBoundingClientRect()?.top || 0;
        window.document.documentElement.style = `--scroll-y: ${window.scrollY}px; --height-y: ${window.innerHeight}px; --render-top-offset: ${renderTopOffset}px;`;
    }, 20)

    /**
     * Save image on disk
     * @returns {{success:Boolean, url:String}} success flag and image url
     */
    @action async saveScreenshoot(){
        this.pendingRequest = true;
        try {
            
            await this.sf.setCameraLookAt(this.sf.defaultCameraPosition.position, this.sf.defaultCameraPosition.target, 0.1);
            const base64 = await this.sf.getScreenshoot();
            // const response = await saveScreenshoot({
            //     base64: base64,
            //     hash: this.hash
            // });
            // return response.data;
            return base64;
        } catch (err) {
            throw err;
        } finally {
            this.pendingRequest = false;
        }

    }
    
    // AR

    @observable arModalVisible = false;
    @observable arLoading = false;
    @action async onCreateAr(e){
        try {
            this.arLoading = true;
            this.showArModal();
            const response = await this.ar.createAr();
            if(response?.success){
                if(isMobileDevice() || isIOS()){
                    this.hideArModal();
                    // window.open(response['url'],'_blank');
                    window.location.href = response['url'];

                }else{
                    this.createQrCode(response['url']);
                }
            }else{
                
            }

        } catch (err) {
            
        }finally{
            this.arLoading = false;
        }
    }
    @action createQrCode(url){
        const canvas = document.getElementById('QrModalCanvas');

        if(canvas){
            setTimeout(()=>{
                QRCode.toCanvas(canvas, url, {width: 180, height:180}, function (error) {
                    if (error){
                        console.error(error)
                    } else{
                        console.log('QR code created!');
                    }
                });
            },100);
        }

    }
    @action showArModal(){
        this.arModalVisible = true;
    }
    @action hideArModal(){
        this.arModalVisible = false;
    }




}

const store = new StoreClass();
window['store'] = store;
export {
    store,
    StoreClass
};
